import { memo } from 'react';
import cn from 'classnames';
import { Tooltip } from 'ht-styleguide';

/* Components */
import CartPreviewIcon from '@components/PageLayouts/Header/Parts/CartPreviewIcon';
import HTLogo from '@components/PageLayouts/Header/Parts/HTLogo';
import PhoneIcon from '@components/PageLayouts/Header/Parts/PhoneIcon';
import { formatPhoneDash, formatPhoneHref } from '@utils/formatting';
import { directBookingTechProfilePath } from '@constants/paths';
import { getDirectBookingTechId, getDirectBookingPhoneNumber } from '@utils/cookies/directBookingCookie';
import Either from '@components/Either';
import Maybe from '@components/Maybe';

/* Styles */
import styles from '../partner.module.scss';

// To Do - format phone number?
const HeaderPartnerDirectBooking = () => {
  const techId = getDirectBookingTechId();

  const getPhoneNumber = () => {
    const phoneInCookie = getDirectBookingPhoneNumber();
    return phoneInCookie || '';
  };

  const phoneNumber = getPhoneNumber();

  return (
    <nav className={cn('htHeaderContainer', styles.container)}>
      <Either condition={Boolean(techId)}>
        <a href={directBookingTechProfilePath(String(techId)!)} className="-no-decoration">
          <HTLogo />
        </a>
        <HTLogo defaultCursor />
      </Either>
      <div className={styles.rightContent}>
        <Maybe condition={phoneNumber}>
          <a href={formatPhoneHref(phoneNumber)} className={cn('p1 -no-decoration marginRight-small1', styles.phoneLink)}>
            <PhoneIcon />
            <Tooltip content="Contact Technician">
              <span className={styles.phoneNumber}>{formatPhoneDash(phoneNumber)}</span>
            </Tooltip>
          </a>
        </Maybe>
        <CartPreviewIcon />
      </div>
    </nav>
  );
};

export default memo(HeaderPartnerDirectBooking);
